
const initialState = {};

const DiscountReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ALL_TAGS':
            return { ...state, tags: action.payload };
        case 'ALL_DISCOUNTS':
            return { ...state, discounts: action.payload };
        case 'ALL_TAG_GROUPS':
            return { ...state, tagGroups: action.payload };
        case 'ALL_VARIANTS_TAGS':
            return { ...state, variantsAndTags: action.payload };
        default:
            return state;
    }
}

export default DiscountReducer;